import { createFileRoute } from "@tanstack/react-router";
import { NeedAccessPage } from "../../components/pages/need-access";
import { searchString } from "../../lib/search";

/** 10a. The API's handoff redirects here: /need-access?app=<slug> */
export const Route = createFileRoute("/_authed/need-access")({
  validateSearch: (search: Record<string, unknown>): { app?: string } => {
    const app = searchString(search.app);
    return app === undefined ? {} : { app };
  },
  component: NeedAccessRoute,
});

function NeedAccessRoute() {
  const { app } = Route.useSearch();
  return <NeedAccessPage slug={app ?? null} />;
}
